module.exports = __webpack_public_path__ + "img/youtube.8198f893.svg";